import axios from "axios";
export default {
  namespaced: true,
  state: {
    volume: 0.20
  },
  getters: {

  },
  mutations: {
    SET_VOLUME(state, volume) {
      state.volume = volume
    }
  },
  actions: {
    async createLessonCheckPoint( _, data){
      return await axios.post('/employee/user-lesson-videos', data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    createPrivateVolume({ commit }, volume){
      commit('SET_VOLUME', volume)
    }
  },
};
